<template>
	<AppAbsoluteMenu
		rounded="lg"
		v-bind="$attrs"
		v-on="$listeners"
		v-model="localValue"
		:maxWidth="MENU_MAX_WIDTH"
		:minWidth="MENU_MIN_WIDTH"
		content-class="absolute-data-input-menu"
	>
		<slot />
	</AppAbsoluteMenu>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
import { DATA_INPUT_MENU_MIN_WIDTH, DATA_INPUT_MENU_MAX_WIDTH } from '../DataInput/DataInputMenu/helpers/data-input-menu.const';
/**
 * DataInputMenuAbsoluteMenuWrapper
 * expected to be pass props to AppAbsoluteMenu component through $attrs={ positionX, positionY }
 *
 * default width: 500px
 */

export default {
	name: 'DataInputMenuAbsoluteMenuWrapper',
	mixins: [VModelMixin],
	computed: {
		MENU_MIN_WIDTH() {
			return DATA_INPUT_MENU_MIN_WIDTH;
		},
		MENU_MAX_WIDTH() {
			return DATA_INPUT_MENU_MAX_WIDTH;
		},
	},
};
</script>
<style scoped lang="scss">
$max-height: 350px;
$border-radius: 8px;
.absolute-data-input-menu {
	max-height: $max-height;
	border-radius: $border-radius !important;
}
</style>
